import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { LinkBase } from './LinkBase/index.js';

var Link = forwardRef(function (_a, ref) {
    var _b = _a.themeKey, themeKey = _b === void 0 ? "link" : _b, sx = _a.sx, linkProps = __rest(_a, ["themeKey", "sx"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps({ sx: sx }, { themeKey: themeKey });
    return jsx(LinkBase, __assign({ ref: ref }, forwardProps, linkProps));
});
Link.displayName = "Link";

export { Link };
//# sourceMappingURL=Link.js.map
